
import { motion } from "framer-motion"
import CodeBlock from "./CodeBlock"
import { Card } from "antd";
import { Button } from 'antd';
import { AlertCircle, Key, Mail, Wrench } from "lucide-react"
import { useState } from "react"
import {  useSelector } from 'react-redux';
import { Toaster, toast } from 'sonner'

const BroadcastTab = () => {
  const [toPhoneNumber, setToPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false)

  const selector = useSelector((state) => state.auth)
  const userApiKey = JSON.parse(selector?.apiKey);

  const templates = [
    {
      type: "Marketing",
      icon: Mail,
      description: "Promotional messages, offers, and campaign announcements",
      examples: ["Special offers", "New product launches", "Event invitations"]
    },
    {
      type: "Utility",
      icon: Wrench,
      description: "Transactional updates, utility and service notifications",
      examples: ["Order updates", "Appointment reminders", "Payment confirmations"]
    },
    {
      type: "Authentication",
      icon: Key,
      description: "Send OTP codes, account verification, and security alerts",
      examples: ["Login verification", "Password reset", "Two-factor authentication"]
    }
  ]

  const handleTest = async (templateType) => {
    const type = templateType.toUpperCase()
    if(type === "MARKETING"){
       sendMarketingMessage()
    }else if(type === "UTILITY"){
      sendUtilityMessage()
    }else if(type === "AUTHENTICATION"){
      sendAuthenticationMessage()
    }
  }


  const sendMarketingMessage = async () => {
    const messageData = {
      messageId: crypto.randomUUID(),
      to: toPhoneNumber,
      from: "254110090747",
      template: {
          name: "broadcast_surveys_usecase",
          languageCode: "en",
          components: {
              header:{
                  type: "IMAGE",
                  mediaUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfkXnlbPr1YqkPYkmTyZULMX-xCoKLENxxaw&s"
              },
              body: {
                  placeholders: [
                      "User",
                  ]
              },
              buttons: [
                  {
                      type: "URL",
                      index: "1",
                      parameter: "7"
                  }
              ]
          }
      }
  }

    if(!messageData.to){
      toast.error('Please enter phone number!')
      return;
    }
    
    try {
        setLoading(true);
        const response = await fetch('https://gateway.lipachat.com/api/v1/whatsapp/template', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apiKey': userApiKey
            },
            body: JSON.stringify(messageData)
        });

        // const result = await response.json();
        if (response.ok) {
          toast.success('Message was successfully sent!')
          setLoading(false);
            
        } else {
           toast.error(`Failed to send message`)
           setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        console.error("Error sending message:", error);
        toast.error("An error occurred while sending the message.")
    }
   };

  const sendUtilityMessage = async () => {
    const messageData = {
      messageId: crypto.randomUUID(),
      to: toPhoneNumber,
      from: "254110090747",
      template: {
          name: "utility_test1",
          languageCode: "en",
          components: {
              header:{
                  type: "IMAGE",
                  mediaUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfkXnlbPr1YqkPYkmTyZULMX-xCoKLENxxaw&s"
              },
              body: {
                  placeholders: [
                      "User",
                  ]
              }
          }
      }
  }

    if(!messageData.to){
      toast.error('Please enter phone number!')
      return;
    }
    
    try {
      setLoading(true);
        const response = await fetch('https://gateway.lipachat.com/api/v1/whatsapp/template', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apiKey': userApiKey
            },
            body: JSON.stringify(messageData)
        });

        // const result = await response.json();
        if (response.ok) {
          toast.success('Message was successfully sent!')
          setLoading(false);
            
        } else {
           toast.error(`Failed to send message`)
           setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        console.error("Error sending message:", error);
        toast.error("An error occurred while sending the message.")
    }
};

const sendAuthenticationMessage = async () => {
  const messageData = {
    messageId: crypto.randomUUID(),
    to: toPhoneNumber,
    from: "254110090747",
    template: {
        name: "lipachat_auth_template",
        languageCode: "en",
        components: {
            body: {
                placeholders: [
                    "123456"
                ]
            },
            buttons:[
               {
                type: "URL",
                index: 0,
                parameter: "123456"
            }
          ]
        }
    }
}

  if(!messageData.to){
    toast.error('Please enter phone number!')
    return;
  }
  
  try {
    setLoading(true);
      const response = await fetch('https://gateway.lipachat.com/api/v1/whatsapp/template', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'apiKey': userApiKey
          },
          body: JSON.stringify(messageData)
      });

      // const result = await response.json();
      if (response.ok) {
        toast.success('Message was successfully sent!')
        setLoading(false);
          
      } else {
         toast.error(`Failed to send message`)
         setLoading(false);
      }
  } catch (error) {
      setLoading(false);
      console.error("Error sending message:", error);
      toast.error("An error occurred while sending the message.")
  }
};

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <h2 className="text-lg font-semibold mb-4">Broadcast & Survey Integration</h2>
        
        <div className="flex items-start space-x-2 p-4 bg-blue-50 rounded-lg mb-6">
          <AlertCircle className="w-5 h-5 text-blue-500 mt-0.5" />
          <div className="text-sm text-blue-700">
            <p className="font-medium mb-1">Important Note:</p>
            <p>No join code is required for broadcast messages. However, you'll need to create and get your templates approved before sending broadcasts. Choose from our pre-approved templates to test sending broadcast/survey.</p>
          </div>
        </div>

        <h3 className="text-lg font-medium mb-2">Test Templates</h3>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700">
            Enter Phone Number to Test
          </label>
          <input
            type="tel"
            value={toPhoneNumber}
            onChange={(e) => setToPhoneNumber(e.target.value)}
            placeholder="e.g., 254712345678"
            className="w-full p-2 border rounded-md"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-4">
          {templates.map((template) => (
            <Card key={template.type} className="p-0 flex">
              <div className="flex items-center space-x-0 mb-3">
                <template.icon className="w-5 h-5 mr-2 text-gray-600" />
                <h4 className="font-medium">{template.type}</h4>
              </div>
              <p className="text-gray-600 text-sm mb-3">{template.description}</p>
              <div className="bg-gray-50 p-3 rounded-md mb-4">
                <p className="text-xs text-gray-500 mb-2">Examples:</p>
                <ul className="text-sm space-y-1">
                  {template.examples.map((example) => (
                    <li key={example} className="text-gray-600">{example}</li>
                  ))}
                </ul>
              </div>
              <Button 
                onClick={() => handleTest(template.type)}
                disabled={loading}
                className="w-full"
              >
                Test {template.type} Template
              </Button>
            </Card>
          ))}
        </div>

        <div >
          <h3 className="text-lg font-medium">Making API Requests</h3>
          <p className="text-gray-600 pb-4">
            Choose your preferred programming language below to see example code for sending broadcast messages
            using our WhatsApp API. Make sure to replace <code className="bg-gray-100 px-2 py-0.5 rounded">YOUR_API_KEY</code> with
            your actual API key. Go to settings page to see <code className="bg-gray-100 px-2 py-0.5 rounded">YOUR_API_KEY</code>. 
          </p>
          <CodeBlock />
          
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <h4 className="font-medium mb-2">Next Steps:</h4>
            <ol className="list-decimal list-inside space-y-2 text-gray-600">
              <li>Create a template in your Lipachat account</li>
              <li>Wait for template approval (usually within 24 hours)</li>
              <li>Use the approved template name in your API requests</li>
              <li>Start sending broadcast messages to your customers</li>
            </ol>
            <Button className="mt-4" onClick={()=> window.open(`https://docs.lipachat.com/api/editor-4/creating-a-template`, "_blank")}>
              Create Template
            </Button>
          </div>
        </div>
        <Toaster position="bottom-right" expand={false} richColors/>
      </div>
    </motion.div>
  )
}

export default BroadcastTab